import ToastNotification, { ToastNotificationProps } from './ToastNotification';

export type { ToastNotificationProps };
export default ToastNotification;
